import React, { useRef, useEffect, useCallback } from 'react';

const Canvas = React.forwardRef(({ width, height, onResize }, ref) => {
  const canvasRef = useRef(null);
  const resizeRef = useRef(false);

  const handleResize = useCallback(() => {
    if (!canvasRef.current) return;
    
    const rect = canvasRef.current.parentElement.getBoundingClientRect();
    canvasRef.current.width = rect.width;
    canvasRef.current.height = rect.height;
    
    // iOS対応: リサイズ時に形状をリセット
    if (onResize) {
      onResize();
    }
  }, [onResize]);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  // refをcanvasRefに転送
  React.useImperativeHandle(ref, () => ({
    canvas: canvasRef.current,
    resize: () => {
      if (!resizeRef.current) {
        resizeRef.current = true;
        handleResize();
        setTimeout(() => {
          resizeRef.current = false;
        }, 100);
      }
    }
  }));

  return (
    <canvas
      ref={canvasRef}
      width={width}
      height={height}
      className="visualizer-canvas"
      style={{
        imageRendering: 'pixelated',
        touchAction: 'none',
        width: '100%',
        height: '100%',
        display: 'block'
      }}
    />
  );
});

Canvas.displayName = 'Canvas';

export default Canvas;